import React, { useState, useEffect } from "react";
import './SplitCompetitionUI.css'

function SplitCompetitionUI(props) {
    const [fencersPerSplit, setFencersPerSplit] = useState(0);
    const [sortedFencers, setSortedFencers] = useState([]);
    const [competitionTiers, setCompetitionTiers] = useState([]);
    const [showPoolSettings, setShowPoolSettings] = useState(false);
    const [pools, setPools] = useState([]);
    const [poolsPerCompetition, setPoolsPerCompetition] = useState([]); // Array to store pools for each competition
    const ratingType = props.selectedRatingType;
    
    console.log(props);
    useEffect(() => {
        calculateFencersPerSplit();
    }, [props.fencers, props.splitCompetitionNumber]);

    // Initialize poolsPerCompetition array when number of competitions changes
    useEffect(() => {
        if (props.splitCompetitionNumber > 0) {
            setPoolsPerCompetition(Array(props.splitCompetitionNumber).fill(0));
        } else {
            setPoolsPerCompetition([]);
        }
    }, [props.splitCompetitionNumber]);

    // Sort fencers whenever fencers or ratingType changes
    useEffect(() => {
        if (props.fencers?.length > 0) {
            // Filter out fencers without a rating for the selected weapon
            const fencersWithRating = props.fencers.filter(fencer => 
                fencer[ratingType] != null && fencer[ratingType] > 0
            );
            
            // Sort by rating (highest first)
            const sorted = [...fencersWithRating].sort((a, b) => 
                b[ratingType] - a[ratingType]
            );
            
            setSortedFencers(sorted);
        }
    }, [props.fencers, ratingType]);

    // Create competition tiers whenever sortedFencers or splitCompetitionNumber changes
    useEffect(() => {
        if (sortedFencers.length > 0 && props.splitCompetitionNumber > 0) {
            createCompetitionTiers();
        } else {
            setCompetitionTiers([]);
        }
    }, [sortedFencers, props.splitCompetitionNumber]);

    const calculateFencersPerSplit = () => {
        if (props.fencers?.length > 0 && props.splitCompetitionNumber > 0) {
            const result = Math.ceil(props.fencers.length / props.splitCompetitionNumber);
            setFencersPerSplit(result);
        } else {
            setFencersPerSplit(0);
        }
    };

    const createCompetitionTiers = () => {
        const numberOfTiers = props.splitCompetitionNumber;
        const tiers = [];
        
        // Calculate base number of fencers per tier
        const totalFencers = sortedFencers.length;
        const baseFencersPerTier = Math.floor(totalFencers / numberOfTiers);
        const remainingFencers = totalFencers % numberOfTiers;
        
        let startIndex = 0;
        
        for (let i = 0; i < numberOfTiers; i++) {
            // Distribute remaining fencers to the first few tiers
            const tierSize = baseFencersPerTier + (i < remainingFencers ? 1 : 0);
            
            // Get fencers for this tier
            const tierFencers = sortedFencers.slice(startIndex, startIndex + tierSize);
            
            tiers.push({
                id: i + 1,
                name: `Tier ${i + 1}`,
                level: i === 0 ? 'Highest Rated' : i === numberOfTiers - 1 ? 'Lowest Rated' : 'Mid Tier',
                fencers: [...tierFencers], // Create a new array
                size: tierSize,
            });
            
            startIndex += tierSize;
        }
        
        setCompetitionTiers(tiers);
    };

    // Function to move a fencer up one tier
    const moveFencerUp = (tierIndex, fencerIndex) => {
        if (tierIndex === 0) return; // Can't move up from first tier

        setCompetitionTiers(prevTiers => {
            const newTiers = JSON.parse(JSON.stringify(prevTiers)); // Deep copy
            const currentTier = newTiers[tierIndex];
            const previousTier = newTiers[tierIndex - 1];
            
            // Get the fencer to move
            const [movedFencer] = currentTier.fencers.splice(fencerIndex, 1);
            
            // Add to previous tier
            previousTier.fencers.push(movedFencer);
            
            // Sort both tiers by rating
            previousTier.fencers.sort((a, b) => b[ratingType] - a[ratingType]);
            currentTier.fencers.sort((a, b) => b[ratingType] - a[ratingType]);
            
            // Update sizes
            previousTier.size = previousTier.fencers.length;
            currentTier.size = currentTier.fencers.length;
            
            return newTiers;
        });
    };

    // Function to move a fencer down one tier
    const moveFencerDown = (tierIndex, fencerIndex) => {
        if (tierIndex === competitionTiers.length - 1) return; // Can't move down from last tier

        setCompetitionTiers(prevTiers => {
            const newTiers = JSON.parse(JSON.stringify(prevTiers)); // Deep copy
            const currentTier = newTiers[tierIndex];
            const nextTier = newTiers[tierIndex + 1];
            
            // Get the fencer to move
            const [movedFencer] = currentTier.fencers.splice(fencerIndex, 1);
            
            // Add to next tier
            nextTier.fencers.push(movedFencer);
            
            // Sort both tiers by rating
            currentTier.fencers.sort((a, b) => b[ratingType] - a[ratingType]);
            nextTier.fencers.sort((a, b) => b[ratingType] - a[ratingType]);
            
            // Update sizes
            currentTier.size = currentTier.fencers.length;
            nextTier.size = nextTier.fencers.length;
            
            return newTiers;
        });
    };

    const isEvenlySeeded = (tierSize, numberOfPools) => {
    if (!numberOfPools || numberOfPools < 1) return true;
    const fencersPerPool = Math.floor(tierSize / numberOfPools);
    const remainingFencers = tierSize % numberOfPools;
    
    return remainingFencers === 0;
    };

    const getRatingValue = (fencer) => {
        return fencer[ratingType] || 'No rating';
    };

    const handleExport = () => {
        setShowPoolSettings(!showPoolSettings);
    };

    // Function to handle pools per competition input change
    const handlePoolsPerCompetitionChange = (index, value) => {
        const numValue = parseInt(value) || 0;
        setPoolsPerCompetition(prev => {
            const newArray = [...prev];
            newArray[index] = numValue;
            return newArray;
        });
    };

    const createPools = () => {
        // Validate that all competitions have a valid number of pools
        const invalidCompetitions = poolsPerCompetition.filter(num => !num || num < 1);
        
        if (invalidCompetitions.length > 0) {
            alert('Please enter a valid number of pools (minimum 1) for all competitions');
            return;
        }

        if (competitionTiers.length === 0) {
            alert('No tiers available to create pools');
            return;
        }

        // Process each tier separately with its own pool count
        competitionTiers.forEach((tier, tierIndex) => {
            const tierFencers = tier.fencers;
            const numberOfPools = poolsPerCompetition[tierIndex];
            
            if (tierFencers.length === 0) return; // Skip empty tiers
            if (!numberOfPools || numberOfPools < 1) return; // Skip if no valid pool number
            
            // Create empty pools for this tier
            const tierPools = Array.from({ length: numberOfPools }, () => []);
            
            // Distribute fencers from this tier into pools using snake draft
            tierFencers.forEach((fencer, index) => {
                const roundNumber = Math.floor(index / numberOfPools);
                const positionInRound = index % numberOfPools;
                
                // Snake draft: reverse order every other round
                const poolIndex = roundNumber % 2 === 0 
                    ? positionInRound 
                    : numberOfPools - 1 - positionInRound;
                    
                tierPools[poolIndex].push({
                    ...fencer,
                    poolNumber: poolIndex + 1
                });
            });

            // Store the pools in state
            setPools(prevPools => {
                const newPools = [...prevPools];
                newPools[tierIndex] = tierPools;
                return newPools;
            });

            // Create CSV content for this tier
            const csvRows = [];
            
            // Flatten pools back into a single list but grouped by pool
            tierPools.forEach((pool) => {
                pool.forEach(fencer => {
                    const name = fencer.name || 'Rogue fencer';
                    const club = fencer.club || 'No Club';
                    const nationality = fencer.nationality || 'Unknown';
                    const poolNumber = fencer.poolNumber;
                    
                    csvRows.push(`${name},${club},${nationality},${poolNumber}`);
                });
            });

            // Generate and download one CSV per tier
            const csvContent = csvRows.join('\n');
            const blob = new Blob(['\uFEFF' + csvContent], { type: 'text/csv;charset=utf-8;' });
            const link = document.createElement('a');
            const url = URL.createObjectURL(blob);
            
            link.href = url;
            link.download = `competition_${tierIndex + 1}_${tier.fencers.length}_fencers_${numberOfPools}pools.csv`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(url);
        });
    };

    return(
        <div className="split-competition-wrapper">
            <button className="close-btn" onClick={() => props.setDisplaySplitCompetitionUI(false)}>X</button>
            <h1>Split Competition</h1>
            <p>Total Fencers: {props.fencers?.length || 0}</p>
            <h2>Number of competitions: {props.splitCompetitionNumber || 0}</h2>
            <span>Set number of splits: </span>
            <select
                value={props.splitCompetitionNumber}
                onChange={(e) => props.setSplitCompetitionNumber(parseInt(e.target.value))}
                >
                <option value="0">0</option>
                <option value="1">1</option>
                <option value="2">2</option>
                <option value="3">3</option>
                <option value="4">4</option>
                <option value="5">5</option>
                <option value="6">6</option>
                <option value="7">7</option>
                <option value="8">8</option>
                <option value="9">9</option>
                <option value="10">10</option>
            </select>
            <button className="accept-button export-button" onClick={handleExport}>Configure Pools</button>
            
            { showPoolSettings && (
                <div className="pool-settings">
                    <button className="close-btn" onClick={handleExport}>X</button>
                    <h2>Pool Configuration</h2>
                    
                    <div className="competitions-pools-config">
                        <h3>Set number of fencers per pool for each competition:</h3>
                        
                        <div className="pools-inputs-grid">
                            {competitionTiers.map((tier, index) => (
                                <div key={tier.id} className="competition-pool-input">
                                    <label htmlFor={`competition ${index + 1}`}>
                                        Competition {index + 1} &nbsp;
                                        <span className="tier-size-badge">{tier.size} fencers</span>
                                        {poolsPerCompetition[index] > 0 ? (
                                            !isEvenlySeeded(tier.size, poolsPerCompetition[index]) ? (
                                                <span className="warning-icon" title="Uneven pools! Some pools will have one more fencer than others.">
                                                🔴
                                                </span>
                                            ) : (
                                                <span className="success-icon" title="Evenly seeded pools">
                                                🟢
                                                </span>
                                            )
                                        ) : (
                                            <span className="neutral-icon" title="Enter number of pools">
                                            ⚪
                                            </span>
                                        )}
                                    </label>
                                    <input
                                        id={`competition-${index + 1}`}
                                        type="number"
                                        min="1"
                                        value={poolsPerCompetition[index] || ''}
                                        onChange={(e) => handlePoolsPerCompetitionChange(index, e.target.value)}
                                        placeholder="Number of fencers"
                                    />
                                    {poolsPerCompetition[index] > 0 && (
                                        <small className="pool-stats">
                                            &nbsp;{Math.ceil(tier.size / poolsPerCompetition[index])} pools
                                            {!isEvenlySeeded(tier.size, poolsPerCompetition[index]) && (
                                                <span className="uneven-note"> (uneven)</span>
                                            )}
                                        </small>
                                    )}
                                </div>
                            ))}
                        </div>
                    </div>
                    
                    <button 
                        className="accept-button create-pools-button" 
                        onClick={createPools}
                        disabled={poolsPerCompetition.some(num => !num || num < 1)}
                    >
                        Create Pools & Download CSVs
                    </button>
                </div>
            )}
            
            <h2>Fencers per competition: {fencersPerSplit}</h2>
            {competitionTiers.length > 0 && (
                <div className="tiers-container">
                    <h3>Competition Tiers:</h3>
                    <div className="tiers-grid">
                        {competitionTiers.map((tier, tierIndex) => (
                            <div key={tier.id} className="tier-card">
                                <div className="tier-header">
                                    <h4>{tier.name}</h4>
                                    <span className="tier-level">{tier.level}</span>
                                    <span className="tier-size">Fencers: {tier.size}</span>
                                    {tier.fencers.length > 0 && (
                                        <span className="rating-range">
                                            Rating: {getRatingValue(tier.fencers[0])} - {getRatingValue(tier.fencers[tier.fencers.length - 1])}
                                        </span>
                                    )}
                                </div>
                                <ul className="tier-fencer-list">
                                    {tier.fencers.map((fencer, fencerIndex) => (
                                        <li key={fencer.id || fencer.name} className="fencer-list-item">
                                            <div className="fencer-content">
                                                <span className="name">
                                                    <span className="rank">{fencerIndex + 1}.</span>
                                                    {fencer.name}
                                                </span>
                                                <span className="club">{fencer.club || 'No club'}</span>
                                                <span className="rating">{getRatingValue(fencer)}</span>
                                            </div>
                                            <div className="move-buttons">
                                                {tierIndex > 0 && (
                                                    <button 
                                                        className="move-btn move-up"
                                                        onClick={() => moveFencerUp(tierIndex, fencerIndex)}
                                                        title="Move to higher tier"
                                                    >
                                                        ↑
                                                    </button>
                                                )}
                                                {tierIndex < competitionTiers.length - 1 && (
                                                    <button 
                                                        className="move-btn move-down"
                                                        onClick={() => moveFencerDown(tierIndex, fencerIndex)}
                                                        title="Move to lower tier"
                                                    >
                                                        ↓
                                                    </button>
                                                )}
                                            </div>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
}

export default SplitCompetitionUI;